import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../services/auth.service';
import { invalidFormValidation } from '../../../../shared/utilities/utility-functions';
import { EnvConfigService } from '../../../../shared/services/env-config.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ButtonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  private readonly _fb = inject(FormBuilder);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly env = inject(EnvConfigService);

  //#region Params
  loginForm!: FormGroup;
  //#endregion

  //#region Methods
  ngOnInit(): void {
    this._initForm();
  }

  _login() {
    if (this.loginForm.invalid) {
      invalidFormValidation(this.loginForm);
      return;
    }
    this.authService.login(this.loginForm.value).subscribe(res => {
      if (res?.success) {
        if (this.env.getConfig().isRunAsLibrary) {
          this.router.navigate(['/dispatch']);
        } else {
          this.router.navigate(['/']);
        }
      }
    });
  }
  //#endregion

  //#region Helpers
  private _initForm(email: string = '') {
    this.loginForm = this._fb.group({
      email: new FormControl(email, [Validators.required]),
      password: new FormControl('', [Validators.required, Validators.min(6)]),
    });
  }
  //#endregion
}
